<template>
  <div class="pad-b-10">
    <div class="shadow pad16">
      <van-row class="font16 bold">
        <van-col>
          {{ item.ccsqdNo }}&nbsp;&nbsp;<span v-show="item.mdd != '---'">{{ item.mdd }}</span>
        </van-col>
      </van-row>

      <div class="font12 gray">
        <van-row>
          <van-col
            :span="4"
          >
            时间：
          </van-col>
          <van-col :span="20">
            {{ item.dateBegin }}--{{ item.dateEnd }}
          </van-col>
        </van-row>

        <van-row>
          <van-col
            :span="4"
          >
            {{ $t('K102','事由') }}：
          </van-col>
          <van-col :span="20">
            {{ item.ccsy }}
          </van-col>
        </van-row>

        <van-row>
          <van-col
            :span="4"
          >
            {{ $t('K130','出差人') }}：
          </van-col>
          <van-col :span="20">
            {{ item.ccr }}
          </van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style lang="less" scoped>
.pad16{
    padding: 16px;
}
.pad-b-10{
    padding-bottom: 10px;
}
</style>